import { useQuery } from '@tanstack/react-query';
import { fetchCountries } from './apiFetchCountries';
import { GlobalReactQueryOptions } from '../../../config';

export const COUNTRIES_QUERY_KEY = 'countries';

interface Props {
    enabled?: boolean;
}
export const useCountries = (props: Props) => {
    const { enabled = true } = props;
    return useQuery([COUNTRIES_QUERY_KEY], fetchCountries, {
        ...GlobalReactQueryOptions,
        enabled
    });
};
